"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinCardRecommendationsError;
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("@ux/button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
function SpinCardRecommendationsError({
  handleCardRecommendationsErrorClick,
  dataCy,
  dataTestId,
  dataEid,
  messageIds
}) {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    "data-testid": dataTestId,
    className: "spins-card-recommendation-error d-flex justify-content-center align-items-center flex-column py-5"
  }, messageIds?.title && /*#__PURE__*/_react.default.createElement("div", {
    className: "ms5 spin-domain-dynamic-font-scaling spins-ai-error-message"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messageIds.title
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ms0 spin-domain-dynamic-font-scaling pt-2"
  }, handleCardRecommendationsErrorClick && messageIds?.buttonText && /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-cy": "spins-card-recommendation-error-link",
    "data-testid": "spins-card-recommendation-error-link",
    design: "inline",
    "data-eid": dataEid,
    onClick: handleCardRecommendationsErrorClick,
    text: formatMessage({
      id: messageIds.buttonText
    })
  })));
}
SpinCardRecommendationsError.propTypes = {
  handleCardRecommendationsErrorClick: _propTypes.default.func,
  dataCy: _propTypes.default.string,
  dataTestId: _propTypes.default.string,
  dataEid: _propTypes.default.string,
  messageIds: _propTypes.default.shape({
    title: _propTypes.default.string,
    buttonText: _propTypes.default.string
  })
};